import { GetterTree } from 'vuex';
import { PersonListState } from '../states.store';

const proposalGetters: GetterTree<PersonListState, {}> = <GetterTree<PersonListState, {}>>{
}

export default proposalGetters;